import { GenericTable } from "@shared/components/GenericTable";
import { PageHeader } from "@shared/components/PageHeader";
import { TableColumn } from "@shared/types/table";
import { Card } from "@shared/ui/card";
import { BarChart3, Wrench } from "lucide-react";
import { useState } from "react";

interface ReadingRecord {
  date: string;
  month: string;
  readType: string;
  reading: number;
  status: 'valid' | 'invalid';
  reader: string;
  validator: string;
}

export const ReaderPerformance = ({ data }: { data?: any[] }) => {
  const readingsData = data ?? [];
  const [currentPage, setCurrentPage] = useState(1);




  const columns: TableColumn<ReadingRecord>[] = [
    {
      key: "name",
      header: "Reader",
      headerTooltip:"Name of the field reader assigned to meters."
    },
    {
      key: "metersRead",
      header: "Meters",
      headerTooltip:"Total meters handled this cycle. Use to balance workload."
    },
    {
      key: "accuracy",
      header: "Accuracy",
      headerTooltip :"Share of validated readings without corrections or flags."
    },
    {
      key: "avgTime",
      header: "Avg. Time",
headerTooltip:"Average time spent per meter. Investigate outliers."
    },
  ];

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
         <Card className="shadow-sm"> 
             <PageHeader
            title="Reader Performance"
            subtitle="Top readers by meters handled and accuracy."
          />

  <div className="pt-2">
     
    <GenericTable
      data={readingsData}
      columns={columns}
      rowKey="date"
      pagination={{
        currentPage,
        totalPages: Math.ceil(readingsData.length / 10), // Assuming 10 items per page
        totalItems: readingsData.length,
        itemsPerPage: 10,
        startItem: (currentPage - 1) * 10 + 1,
        endItem: Math.min(currentPage * 10, readingsData.length)
      }}
      onPageChange={handlePageChange}
      searchPlaceholder="Search readings..."
      emptyMessage="No readings found"
    />

</div>
    </Card>)
};